class ESACustomBundle extends HTMLElement {
  constructor() {
    super();

    this.selectedItems = {};
  }

  connectedCallback() {
    this.cacheDom();
    this.bindEvents();

    this.setInitialBundle();
    this.handleSubscriptionToggle();
    this.updateBundleState();
    this.updateFlavourAvailability();
    const readableItems = [];
    const bundleData = [];
  }

  cacheDom() {
    this.bundleCards = [...this.querySelectorAll('.esb__bundle-card')];
    this.flavourCards = [...this.querySelectorAll('.esb__flavour-card')];

    this.summary = this.querySelector('.esb__bundle-summary');
    this.atcButton = this.querySelector('.esb__bundle-atc');
    this.atcText = this.querySelector('.esb__bundle-atc-text');

    this.subtotalPrice = this.querySelector('.esb__bundle-subtotal-price');
    this.savingPrice = this.querySelector('.esb__bundle-savings-price');

    this.subscription = this.querySelector('.esb__subscription');
    this.subscriptionInput = this.querySelector('.esb__subscription-input');

    this.variantInput = this.querySelector('input[name="id"]');
    this.itemsInput = this.querySelector('input[name="properties[Items]"]');

    this.giftSelector = this.querySelector('.esb__gift-selector');
    this.errorEl = this.querySelector('.esb__bundle-error');

    this.tiersData = JSON.parse(
      this.querySelector('noscript[data-tiers]')?.dataset.tiers || '{}'
    );
  }

  bindEvents() {
    this.bundleCards.forEach(card => {
      card.addEventListener('click', () => {
        this.selectBundle(card);
      });
    });

    this.flavourCards.forEach(card => {

      const plus = card.querySelector('.esb__qty-btn--plus');
      const minus = card.querySelector('.esb__qty-btn--minus');
      const input = card.querySelector('.esb__qty-input');

      plus?.addEventListener('click', () => {
        this.changeQty(card, 1);
      });

      minus?.addEventListener('click', () => {
        this.changeQty(card, -1);
      });

      input?.addEventListener('change', () => {
        this.validateQty(card);
      });
    });

    this.subscriptionInput?.addEventListener('change', () => {
      this.handleSubscriptionToggle();
    });

    this.atcButton?.addEventListener('click', e => {
      this.handleAddToCart(e);
    });
  }

  setInitialBundle() {

    const activeCard =
      this.querySelector('.esb__bundle-card--active') ||
      this.bundleCards[0];

    if (activeCard) {
      this.selectBundle(activeCard);
    }
  }

  selectBundle(card) {
    this.bundleCards.forEach(item => item.classList.remove('esb__bundle-card--active'));

    card.classList.add('esb__bundle-card--active');
    this.activeBundle = card;
    this.requiredItems = parseInt(card.dataset.maxLimit || 0);

    if (this.variantInput) this.variantInput.value = card.dataset.variantId;

    this.summary.dataset.requiredItems = this.requiredItems;

    this.resetFlavours();

    this.handleSubscriptionToggle();
    this.updateGiftState();
    this.updateBundleState();
    this.updateProductInputs();
    this.updateQtyButtons();
    this.updateFlavourAvailability();
  }

  changeQty(card, delta) {
    const input = card.querySelector('.esb__qty-input');
    const controls = card.querySelector('.esb__qty-controls');

    if (!input) return;

    let qty = parseInt(input.value || 0);

    const totalSelected = this.getTotalSelected();
    const maxLimit = parseInt(this.requiredItems || 0);

    const inventoryPolicy = card.dataset.inventoryPolicy || '';
    const inventoryManagement = card.dataset.inventoryManagement || '';
    const inventory = parseInt(card.dataset.inventory || 0);

    const managesInventory = inventoryManagement !== '';
    const inventoryDenied = inventoryPolicy === 'deny';

    if (delta > 0 && totalSelected >= maxLimit) {
      return;
    }

    if (delta > 0 && managesInventory && inventoryDenied && qty >= inventory) {
      return;
    }

    qty += delta;

    if (qty < 0) {
      qty = 0;
    }

    if (managesInventory && inventoryDenied && qty > inventory) {
      qty = inventory;
    }

    input.value = qty;

    if (qty > 0) {
      controls?.classList.add('esb__qty-enabled');
    } else {
      controls?.classList.remove('esb__qty-enabled');
    }

    const tierId = this.getTierId(qty);
    card.dataset.tierId = tierId;

    this.updateQtyButtons();
    this.updateFlavourAvailability();
    this.updateBundleState();
    this.updateProductInputs();
  }

  validateQty(card) {

    const input = card.querySelector('.esb__qty-input');

    const controls = card.querySelector('.esb__qty-controls');

    let qty = parseInt(input.value || 0);

    if (qty < 0) {
      qty = 0;
    }

    input.value = qty;

    if (qty > 0) {
      controls.classList.add('esb__qty-enabled');
    } else {
      controls.classList.remove('esb__qty-enabled');
    }

    this.updateQtyButtons();
    this.updateBundleState();
  }

  getTotalSelected() {
    let total = 0;

    this.flavourCards.forEach(card => {
      total += parseInt(card.querySelector('.esb__qty-input').value || 0);
    });

    return total;
  }

  updateQtyButtons() {
    const totalSelected = this.getTotalSelected();
    const maxLimit = parseInt(this.requiredItems || 0);

    this.flavourCards.forEach(card => {
      const plus = card.querySelector('.esb__qty-btn--plus');

      if (!plus) return;

      const input = card.querySelector('.esb__qty-input');
      const qty = parseInt(input?.value || 0);

      const inventoryPolicy = card.dataset.inventoryPolicy || '';
      const inventoryManagement = card.dataset.inventoryManagement || '';
      const inventory = parseInt(card.dataset.inventory || 0);

      const managesInventory = inventoryManagement !== '';
      const inventoryDenied = inventoryPolicy === 'deny';

      const bundleLimitReached = totalSelected >= maxLimit;
      const inventoryLimitReached = managesInventory && inventoryDenied && qty >= inventory;

      plus.disabled = bundleLimitReached || inventoryLimitReached || card.dataset.available !== 'true';
    });
  }

  updateGiftState() {
    if (!this.subscription) return;

    const unlockOptions = (this.subscription.dataset.unlockOptions || '').split(',').map(item => item.trim());
    const currentPack = this.activeBundle?.dataset.value || '';

    const unlocked = this.subscriptionInput.checked &&
      unlockOptions.some(option => option === currentPack);

    this.subscription.dataset.giftUnlocked = unlocked;

    if (this.giftSelector) {
      this.giftSelector.style.display = unlocked ? '' : 'none';
    }
  }

  updateBundleState() {
    this.readableItems = [];
    this.bundleData = [];

    this.flavourCards.forEach(card => {
      const qty = parseInt(card.querySelector('.esb__qty-input').value || 0);
      if (!qty) return;
      const variantId = card.dataset.variantId;
      const sku = card.dataset.sku;
      const title = card.dataset.title;
      this.readableItems.push(`${title} x${qty}`);
      this.bundleData.push(`${variantId}_${qty}`);
    });

    if (this.itemsInput) {
      this.itemsInput.value = this.readableItems.join(', ');
    }

    const selected = this.getTotalSelected();
    const required = parseInt(this.requiredItems || 0);
    const complete = selected === required;

    if (complete) {
      this.atcButton.dataset.disabled = 'false';
      this.atcText.textContent = this.summary.dataset.completeText;
    } else {
      const remaining = Math.max(required - selected, 0);
      this.atcButton.dataset.disabled = 'true';
      this.atcText.textContent = this.summary.dataset.incompleteText.replace('||count||', remaining);
    }
  }

  updateSummaryPrices() {

    if (!this.activeBundle) return;

    const isSubscription = this.subscriptionInput.checked;

    const subtotal = isSubscription ? this.activeBundle.dataset.subPrice : this.activeBundle.dataset.otPrice;

    const savePrice = isSubscription ? this.activeBundle.dataset.subSavePrice : this.activeBundle.dataset.otSavePrice;

    const hasSaving = savePrice && !savePrice.includes('0,0') && !savePrice.includes('0.0');

    if (this.subtotalPrice) this.subtotalPrice.textContent = subtotal;

    const savingWrapper = this.querySelector('.esb__bundle-savings');

    if (savingWrapper) {
      savingWrapper.style.display = hasSaving ? '' : 'none';
    }

    if (this.savingPrice && hasSaving) {
      this.savingPrice.textContent = savePrice;
    }
  }

  handleSubscriptionToggle() {

    const isSubscription = this.subscriptionInput.checked;

    this.bundleCards.forEach(card => {

      const comparePrice = card.dataset.comparePrice;
      const bundlePrice = isSubscription ? card.dataset.subPrice : card.dataset.otPrice;
      const eachPrice = isSubscription ? card.dataset.subEachPrice : card.dataset.otEachPrice;
      const discount = isSubscription ? card.dataset.subDiscount : card.dataset.otDiscount;
      const savePrice = isSubscription ? card.dataset.subSavePrice : card.dataset.otSavePrice;

      const currentPriceEl = card.querySelector('.esb__bundle-current-price');
      const comparePriceEl = card.querySelector('.esb__bundle-compare-price');
      const eachPriceEl = card.querySelector('.esb__bundle-each-price');
      const badgeEl = card.querySelector('.esb__bundle-badge');

      const hasSaving = savePrice && !savePrice.includes('0,00') && !savePrice.includes('0.00');

      const hasDiscount = discount && discount.toLowerCase() !== '0% off';

      if(currentPriceEl) currentPriceEl.textContent = bundlePrice;

      if(eachPriceEl) eachPriceEl.textContent = eachPrice;

      if (badgeEl) {
        badgeEl.textContent = discount;
        badgeEl.style.display = hasDiscount ? '' : 'none';
      }

      if (comparePriceEl) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.style.display = hasSaving ? '' : 'none';
      }

      this.flavourCards.forEach(card => {
        const input = card.querySelector('.esb__qty-input');
        const tierId = this.getTierId(input.value);
        card.dataset.tierId = tierId;
      });
    });

    this.updateSummaryPrices();
    this.updateGiftState();
    this.updateProductInputs();
  }
  
  updateProductInputs() {
    if (!this.activeBundle) return;

    if (this.variantInput) {
      this.variantInput.value = this.activeBundle.dataset.variantId;
    }

    const sellingPlanInput = this.querySelector('input[name="selling_plan"]');
    if (!sellingPlanInput) return;

    sellingPlanInput.value = this.subscriptionInput.checked && this.activeBundle.dataset.sellingPlan ? this.activeBundle.dataset.sellingPlan : '';
  }

  resetFlavours() {
    this.flavourCards.forEach(card => {
      const input = card.querySelector('.esb__qty-input');
      const controls = card.querySelector('.esb__qty-controls');
      const plus = card.querySelector('.esb__qty-btn--plus');
      const minus = card.querySelector('.esb__qty-btn--minus');

      if (input) {
        input.value = 0;
      }

      card.dataset.tierId = '';
      controls?.classList.remove('esb__qty-enabled');

      if (plus) {
        plus.disabled = false;
      }
      if (minus) {
        minus.disabled = true;
      }
      if (input) {
        input.disabled = false;
      }
    });

    if (this.itemsInput) {
      this.itemsInput.value = '';
    }

    if (this.atcButton) {
      this.atcButton.dataset.disabled = 'true';
    }

    if (this.atcText && this.summary?.dataset?.incompleteText) {
      this.atcText.textContent = this.summary.dataset.incompleteText.replace('||count||', this.requiredItems);
    }
  }

  showError(message) {
    if (!this.errorEl) return;
    clearTimeout(this.errorTimeout);
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
    this.errorTimeout = setTimeout(() => {
      this.errorEl.hidden = true;
    }, 4000);
  }

  scrollToFlavours() {
    const flavours = this.querySelector('.esb__flavours');
    if (!flavours) return;

    flavours.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  handleAddToCart(e) {
    e.preventDefault();
    const selected = this.getTotalSelected();
    const required = parseInt(this.requiredItems || 0);
    if (selected < required) {
      this.scrollToFlavours();
      return;
    }

    if (selected > required) {
      this.showError(`Maximum ${required} flavours allowed.`);
      return;
    }

    this.submitBundle();
  }

  generateBundleId() {
    return `bundle_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;
  }

  async submitBundle() {
    try {
      this.loading = true;
      this.atcButton.classList.add('loading-atc');

      const bundleId = this.generateBundleId();

      const items = [];

      const bundleItem = {
        id: Number(this.activeBundle.dataset.variantId),
        quantity: 1,
        properties: {
          Items: this.itemsInput.value,
          _is_bundle: 'true',
          _bundle_id: bundleId
        }
      };

      if (this.subscriptionInput.checked && this.activeBundle?.dataset?.sellingPlan) {
        bundleItem.selling_plan = Number(this.activeBundle.dataset.sellingPlan);
      }

      items.push(bundleItem);

      this.bundleData.forEach(bundleItemData => {
        const [variantId, qty] = bundleItemData.split('_');
        
        const card = this.flavourCards.find(card => card.dataset.variantId === variantId);
        const tierId = this.getTierId(qty);
        
        const item = {
          id: Number(variantId),
          quantity: Number(qty),
          parent_id: Number(this.activeBundle.dataset.variantId),
          properties: {
            _bundle_item: 'true',
            _selected_tier: tierId,
            _bundle_id: bundleId
          }
        };
        
        if (this.subscriptionInput.checked && card?.dataset.sellingPlan) {
          item.selling_plan = Number(card.dataset.sellingPlan);
        }
        
        items.push(item);
      });

      const giftVariantId = this.getSelectedGiftVariantId();
      const giftTierId = this.getSelectedGiftTierId() || '';

      if (this.isGiftUnlocked() && giftVariantId) {
        items.push({
          id: Number(giftVariantId),
          quantity: 1,
          parent_id: Number(this.activeBundle.dataset.variantId),
          properties: {
            _free_gift: 'true',
            _selected_tier: giftTierId,
            _bundle_id: bundleId
          }
        });
      }

      const payload = {
        items
      };

      const addResponse = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify(payload)});
      const addData = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(addData.description || addData.message || 'Unable to add bundle.');
      }

      const sectionsResponse = await fetch(`${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count`);

      const sectionsText = await sectionsResponse.text();
      const sections = JSON.parse(sectionsText);

      document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
        bubbles: true,
        detail: {
          response: {
            ...addData,
            sections
          },
          sourceId: 'esa-custom-bundle'
        }
      }));
    } catch (error) {
      this.showError(error?.message || 'Unable to add bundle.');
    } finally {
      this.loading = false;
      this.atcButton.classList.remove('loading-atc');
    }
  }

  getTierId(quantity) {
    if (!this.tiersData?.tiers?.length) return '';
    const purchaseType = this.subscriptionInput.checked ? 'SUBSCRIPTION' : 'ONE_TIME';
    const bundleTitle = this.activeBundle?.dataset.value;
    const tier = this.tiersData.tiers.filter(item =>
      item.purchase_type === purchaseType &&
      item.offerTitle.includes(bundleTitle) &&
      Number(quantity) >= Number(item.quantity)
    ).sort((a, b) => Number(b.quantity) - Number(a.quantity))[0];
    return tier?.id || '';
  }

  getSelectedGiftVariantId() {
    const gift = this.querySelector('.esb__gift-radio:checked');
    return gift?.value || null;
  }

  getSelectedGiftTierId() {
    const gift = this.querySelector('.esb__gift-radio:checked');
    return gift?.dataset.tierId || null;
  }

  isGiftUnlocked() {
    return (this.subscriptionInput.checked && this.subscription?.dataset.giftUnlocked === 'true' && this.giftSelector);
  }

  updateFlavourAvailability() {
    const soldText = this.dataset.soldText || 'Sold out';

    this.flavourCards.forEach(card => {
      const plus = card.querySelector('.esb__qty-btn--plus');
      const minus = card.querySelector('.esb__qty-btn--minus');
      const input = card.querySelector('.esb__qty-input');
      const qtyText = card.querySelector('.esb__qty-text');

      if (!plus || !input) return;

      const available = card.dataset.available === 'true';
      const inventoryPolicy = card.dataset.inventoryPolicy || '';
      const inventoryManagement = card.dataset.inventoryManagement || '';
      const inventory = parseInt(card.dataset.inventory || 0);
      const qty = parseInt(input.value || 0);

      const managesInventory = inventoryManagement !== '';
      const inventoryDenied = inventoryPolicy === 'deny';
      const soldOut = !available || (managesInventory && inventoryDenied && inventory <= 0);

      if (soldOut) {
        plus.disabled = true;
        minus.disabled = true;
        input.disabled = true;

        if (qtyText) {
          qtyText.textContent = soldText;
        }

        card.classList.add('esb__flavour-card--sold-out');
        return;
      }

      card.classList.remove('esb__flavour-card--sold-out');

      input.disabled = false;
      minus.disabled = qty <= 0;

      if (qtyText) {
        qtyText.textContent = '+ Add';
      }

      if (managesInventory && inventoryDenied) {
        plus.disabled = qty >= inventory;
      } else {
        plus.disabled = false;
      }
    });

    this.updateQtyButtons();
  }
}

customElements.define( 'esa-custom-bundle', ESACustomBundle);